import React, { CSSProperties, FC } from 'react';
import { useTheme } from '../../../../hooks/useTheme';
import styles from './Chevron.module.css';

const points = [
  '10',
  '1.86321757',
  '8.10810809',
  '0',
  '0',
  '7.98521826',
  '8.10810809',
  '15.9704364',
  '10',
  '14.1072189',
  '3.78378374',
  '7.98521826',
].join(' ');

export interface ChevronIconProps {
  title?: string;
  direction?: Direction;
  s?: CSSProperties;
}

export enum Direction {
  Up = 'up',
  Down = 'down',
  Left = 'left',
  Right = 'right',
}

const transforms: Record<Direction, string> = {
  [Direction.Up]: 'translate(8, 4) rotate(90 4 4)',
  [Direction.Down]: 'translate(0, 8) rotate(270 4 4)',
  [Direction.Left]: 'translate(0, 0) rotate(0 4 4)',
  [Direction.Right]: 'translate(4, 8) rotate(180 4 4)',
};

const ChevronIcon: FC<ChevronIconProps> = ({
  title = 'Combobox arrow',
  s = {},
  direction = Direction.Left,
}) => {
  const { iconsPrimaryNone } = useTheme();
  const style = { ...iconsPrimaryNone, ...s };

  return (
    <svg
      aria-labelledby="nth-bit-icon-chevron-title"
      role="img"
      className={styles.container}
      style={{ fill: s.color, ...style }}
      viewBox="0 0 16 16"
    >
      <title id="nth-bit-icon-chevron-title">{title}</title>
      <polygon
        points={points}
        transform={transforms[direction || Direction.Left]}
      />
    </svg>
  );
};

export default ChevronIcon;
